import { useFormContext } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

export default function useSendInvoiceDialog({ setOpen }: { setOpen: (open: boolean) => void }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const form = useFormContext();

  const handleOk = () => {
    setOpen(false);
    form.reset();
    searchParams.set("tab", "package");
    setSearchParams(searchParams);
  };

  return {
    handleOk,
  };
}
